import { render, staticRenderFns } from "./SupervisorsDetails.vue?vue&type=template&id=4239730b&scoped=true"
import script from "./SupervisorsDetails.vue?vue&type=script&lang=js"
export * from "./SupervisorsDetails.vue?vue&type=script&lang=js"
import style0 from "./SupervisorsDetails.vue?vue&type=style&index=0&id=4239730b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4239730b",
  null
  
)

export default component.exports